export default "__VITE_ASSET__CsLThKwJ__"